export default __webpack_public_path__ + "static/media/home_web-md@2x.af8b5818.jpg";